// EXEMPT
import { GAME_SHORT_NAMES } from "@/app/constants.mjs";
import type { GameSymbol } from "@/app/games.mjs";
import { GAME_SYMBOL_CS2 } from "@/game-csgo/definition-symbol.mjs";
import { GAME_SYMBOL_LOL } from "@/game-lol/definition-symbol.mjs";
import { GAME_SYMBOL_TFT } from "@/game-tft/definition-symbol.mjs";
import { GAME_SYMBOL_VAL } from "@/game-val/definition-symbol.mjs";
import SymbolMap from "@/util/symbol-map.mjs";

const GAME_SYMBOL_MAP = {
  ...SymbolMap.invert(GAME_SHORT_NAMES),

  // custom mappings
  league: GAME_SYMBOL_LOL,
  val: GAME_SYMBOL_VAL,
  tft: GAME_SYMBOL_TFT,
  csgo: GAME_SYMBOL_CS2,
} as const;

export function SymbolGame(
  // the purpose of this function is to cast unknown to symbols
  // not necessarily to pass in already valid values.
  value: keyof typeof GAME_SYMBOL_MAP | GameSymbol | unknown,
): GameSymbol {
  if (typeof value === "symbol") return value as GameSymbol;
  return GAME_SYMBOL_MAP[
    `${value}`.toLowerCase() as keyof typeof GAME_SYMBOL_MAP
  ];
}
